export enum TaxpayerType {
  Individual = 'individual',
  Business = 'business',
}
